import { render } from "./comp-menu-child.vue?vue&type=template&id=6219cfd9&ts=true"
import script from "./comp-menu-child.vue?vue&type=script&lang=ts"
export * from "./comp-menu-child.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__